import axiosClient from '@clients/axiosClient';
import { ChargePlan } from '@clients/domains/lending/chargePlan';
import {
    GetLoan,
    GetLoans,
    LoanItem,
    LoanItemExpanded,
    Loans,
    PostRepayment,
    GetProduct,
    PostDisbursement,
} from '@clients/domains/lending/lending';
import { LoanProduct } from '@clients/domains/lending/loanProduct';

const loans = () => {
    const client = axiosClient();

    return {
        async getLoans({ entityId }: GetLoans) {
            const { data } = await client.get<Loans>(`lending/v1/loans`, {
                params: {
                    entityId: entityId,
                    limit: 10,
                },
            });
            return data;
        },
        async getLoan({ loanId, expand = false }: GetLoan) {
            const { data } = await client.get<LoanItem | LoanItemExpanded>(
                `lending/v1/loans/${loanId}`,
                { params: { expand } },
            );
            return data;
        },
        async deleteLoan({ loanId }: GetLoan) {
            const { data } = await client.delete<LoanItem>(
                `lending/v1/loans/${loanId}`,
            );
            return data;
        },
        async getChargePlan(chargePlanCode: string) {
            const { data } = await client.get<ChargePlan>(
                `/lending/v1/charge-plans/${chargePlanCode}`,
            );
            return data;
        },
        async getProduct({ id }: GetProduct) {
            const { data } = await client.get<LoanProduct>(
                `/lending/v1/loan-products/${id}`,
            );
            return data;
        },
        async postRepayment({ loan_id, dataToSubmit }: PostRepayment) {
            const { data } = await client.post(
                `lending/v1/loans/${loan_id}/repayment`,
                {
                    ...dataToSubmit,
                },
            );
            return data;
        },
        async postDisbursement({ loan_id, dataToSubmit }: PostDisbursement) {
            const { data } = await client.post(
                `lending/v1/loans/${loan_id}/disburse`,
                {
                    ...dataToSubmit,
                },
            );

            return data;
        },
    };
};

export default loans;
